{
  "name": "babel-design-system",
  "version": "0.0.1",
  "description": "Vue-powered documentation and self-hostable assets for the Babel design system.",
  "private": true,
  "type": "module",
  "main": "www/latest/babel.js",
  "scripts": {
    "dev": "vite --host 0.0.0.0 --port 8070",
    "watch": "npm run dev",
    "build": "vite build && node scripts/build/release.mjs",
    "preview": "vite preview --host 0.0.0.0 --port 8070",
    "serve": "npm run build && firebase emulators:start --only hosting",
    "deploy": "npm run build && firebase deploy --only hosting",
    "deploy:preview": "npm run build && firebase hosting:channel:deploy preview",
    "typecheck": "vue-tsc --noEmit",
    "test": "npm run typecheck && npm run build"
  },
  "keywords": [
    "Babel",
    "Design System",
    "Vue",
    "Vite",
    "Firebase Hosting"
  ],
  "author": "AM",
  "license": "MIT",
  "homepage": "https://babel.lozd.com",
  "engines": {
    "node": ">=20"
  },
  "dependencies": {
    "@lucide/vue": "^1.0.0",
    "pinia": "^3.0.4",
    "vue": "^3.5.38"
  },
  "devDependencies": {
    "@vitejs/plugin-vue": "^6.0.7",
    "archiver": "^8.0.0",
    "esbuild": "^0.28.1",
    "firebase-tools": "^15.22.0",
    "fs-extra": "^11.2.0",
    "sass": "^1.101.0",
    "typescript": "^5.9.3",
    "vite": "^8.0.16",
    "vue-tsc": "^3.3.5"
  }
}
